import React from 'react';
import { motion } from 'framer-motion';
import { Share2, Award, CheckCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';

export default function VictoryCelebration({ achievement, onClose }) {
    if (!achievement) return null;

    const handleShare = () => {
        navigator.clipboard.writeText(`Desbloqueie a conquista: ${achievement.label} no AIFT Platform! 🚀`);
        toast.success("Link copiado para a área de transferência!");
    };

    return (
        <div className="absolute inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm">
            <motion.div
                initial={{ opacity: 0, scale: 0.9, y: 20 }}
                animate={{ opacity: 1, scale: 1, y: 0 }}
                exit={{ opacity: 0, scale: 0.9, y: 20 }}
                className="relative w-full max-w-md bg-[#0B0E14] border border-aift-orange/50 shadow-[0_0_50px_rgba(249,115,22,0.1)] overflow-hidden"
            >
                {/* Technical Decorators */}
                <div className="absolute top-0 left-0 w-2 h-2 border-t-2 border-l-2 border-aift-orange" />
                <div className="absolute top-0 right-0 w-2 h-2 border-t-2 border-r-2 border-aift-orange" />
                <div className="absolute bottom-0 left-0 w-2 h-2 border-b-2 border-l-2 border-aift-orange" />
                <div className="absolute bottom-0 right-0 w-2 h-2 border-b-2 border-r-2 border-aift-orange" />

                {/* Scanline Background */}
                <div className="absolute inset-0 bg-[linear-gradient(rgba(249,115,22,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(249,115,22,0.03)_1px,transparent_1px)] bg-[size:20px_20px] pointer-events-none" />

                <div className="relative p-8 text-center">
                    <motion.div
                        initial={{ scale: 0, rotate: -180 }}
                        animate={{ scale: 1, rotate: 0 }}
                        transition={{ type: "spring", damping: 12 }}
                        className="w-24 h-24 mx-auto mb-6 bg-aift-orange/10 rounded-full flex items-center justify-center border-2 border-aift-orange relative"
                    >
                        <div className="absolute inset-0 border border-aift-orange/30 rounded-full animate-ping" />
                        <Award className="w-12 h-12 text-aift-orange" />
                    </motion.div>

                    <div className="mb-2 flex items-center justify-center gap-2 text-[#A3E635] font-mono text-xs uppercase tracking-widest">
                        <CheckCircle className="w-3 h-3" />
                        <span>Achievement_Unlocked</span>
                    </div>

                    <motion.h2
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        delay={0.2}
                        className="text-2xl font-bold text-[#FDF4DC] mb-2 font-heading tracking-tight uppercase"
                    >
                        {achievement.label || "Conquista Desbloqueada"}
                    </motion.h2>

                    <p className="text-sm font-mono text-muted-foreground mb-8 text-center">
             // PROTOCOL: SINGULARITY_STEP_COMPLETE
                        <br />
                        Status: Confirmed
                    </p>

                    <div className="flex gap-3 justify-center">
                        <Button
                            onClick={handleShare}
                            variant="outline"
                            className="border-[#81B7E6] text-[#81B7E6] hover:bg-[#81B7E6]/10 rounded-none font-mono text-xs uppercase tracking-wider"
                        >
                            <Share2 className="w-4 h-4 mr-2" /> Share_Log
                        </Button>
                        <Button
                            onClick={onClose}
                            className="bg-[#F97316] text-[#0B0E14] hover:bg-white hover:text-black rounded-none font-mono text-xs uppercase tracking-wider font-bold"
                        >
                            Continue_Exec
                        </Button>
                    </div>
                </div>
            </motion.div>
        </div>
    );
}
